import clsx from 'clsx';
import ReactMarkdown from 'react-markdown';
import rehypeHighlight from 'rehype-highlight';
import remarkGfm from 'remark-gfm';

/**
 * Renders the markdown used by notes, topic notes and solution explanations.
 * Fenced code blocks are highlighted by highlight.js; the theme is defined with
 * CSS variables in index.css so it works in both colour schemes.
 */
export function Markdown({ children, className }: { children: string; className?: string }) {
  if (!children.trim()) {
    return <p className={clsx('text-sm italic text-muted', className)}>Одоогоор юу ч бичээгүй.</p>;
  }
  return (
    <div className={clsx('prose-notes', className)}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[[rehypeHighlight, { detect: true, ignoreMissing: true }]]}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
